import { placeholderForEmpty } from 'components/atoms/table/formatters/empty-value-formatter';

export const PLACEHOLDER = placeholderForEmpty;
